import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { DatabaseService } from "../../core/_services/database.service";
import { Observable } from "rxjs/internal/Observable";
import { Observer } from "rxjs";
import { Lottery } from "../_shared/lottoloca-commom/lottery-modex";
import { LotteryTask, LotteryTaskStatuses } from "../../core/_shared/models/task.model";
import { TaskQueue } from "../../core/_shared/models/task-queue.model";
import { Pager } from "../../core/_shared/pager";
import { List } from "linqts";
import { BetTaskTypes } from '../../core/_shared/models/BetTaskTypes';
import { IDocumentReference } from './database-cast/IDatabase';
import { HttpClient } from '@angular/common/http';
import { Bet } from '../../core/_shared/models/bet.model';
import { UserService } from './user.service';
import { Filter } from '../_shared/models/filter.model';
import { License } from '../_shared/models/Customer';
import { MyDictionary } from "../_shared/lottoloca-commom/my-dictionaryx";
import { DeviceDetectorService } from 'ngx-device-detector';
import { BetItem } from "../_shared/bet-item.model";


@Injectable()
export class LotteryService {


    betListPageSize: number = 20;
    configFiltersPageSize: number = 50;
    _configFiltersSearch: MyDictionary<any> = new MyDictionary<any>();
    _betListSearch: MyDictionary<any> = new MyDictionary<any>();

    setConfigFiltersSearch(search: string) {

        this._configFiltersSearch[this.getCurrentLotteryId()] = search;

    }
    getConfigFiltersSearch(): string {


        if (this._configFiltersSearch.containsKey(this.getCurrentLotteryId())) {
            return this._configFiltersSearch[this.getCurrentLotteryId()];
        }
        return "";

    }

    setBetListSearch(search: string) {

        this._betListSearch[this.getCurrentLotteryId()] = search;

    }
    getBetListSearch(): string {


        if (this._betListSearch.containsKey(this.getCurrentLotteryId())) {
            return this._betListSearch[this.getCurrentLotteryId()];
        }
        return "";

    }


    ConvertToNumberDescription(numbers: string): string {


        let numbersArray = numbers.split(' ');

        let result = '';

        numbersArray.forEach(element => {
            result += this.lottery.NumberList.find(x => x.value == parseInt(element)).description + ' ';
        });

        return result.trim();

    }


    // _licenses: any[];
    public lotteryId: string;
    public lottery: Lottery;
    public observers: Observer<Lottery>[] = [];
    public lotteryFilters: Filter[];
    public filterslotteryId: string;


    public currentLotteryModeObserver(): Observable<Lottery> {

        return Observable.create((observer: Observer<Lottery>) => {

            this.observers.push(observer);

        });
    }


    public setCurrentLotteryId(lotteryId: string): void {


        this.lotteryId = lotteryId;


    }

    public getCurrentLotteryId(): string {
        return this.lotteryId;
    }



    public getBet2(key: string): IDocumentReference {

        return this._database.getBet2(key, this.lotteryId);
    }


    public getBetDoc(key: string): any {

        return this._database.getBetDoc(key, this.lotteryId);
    }

    public async getBetSolution(bet: Bet, pager: Pager): Promise<BetItem[]> {
        if(bet.lotteryId != this.lotteryId)
            {
        
                return [];
            }
        return this._database.getBetSolution(bet, this.lotteryId, pager);

    }



    constructor(private auth: UserService, private _database: DatabaseService, public deviceService: DeviceDetectorService,
        private http: HttpClient, private router: Router) {






    }

    public getDeviceType(): string {
        if (this.deviceService.isDesktop()) {
            return "Desktop";
        }

        if (this.deviceService.isMobile()) {
            return "Mobile";
        }

        if (this.deviceService.isTablet()) {
            return "Tablet";
        }

        return "none";
    }

    public getCurrentLotteryMode(): Promise<Lottery> {


        let promise = new Promise<Lottery>((resolve, reject) => {
            if (this.lottery == null || this.lottery.id != this.lotteryId) {

                this._database
                    .getLotteries()
                    .getLottery(this.lotteryId)
                    .getData()
                    .then(lottery => {
                        this.lottery = lottery;


                        this.observers.forEach(observer => {
                            observer.next(this.lottery);
                        });

                        resolve(this.lottery);
                    })
                    .catch(error => {
                        reject(error);
                    })
            }
            else {

                resolve(this.lottery);
            }


        });

        return promise;


    }


      public searchLotteryFilters(searchText:string,lotteryId:string): Promise<any[]> {


        let promise = new Promise<any[]>((resolve, reject) => {
 
                this._database
                    .getLottery(lotteryId)
                    .getFilters()
                    .getCollection()
                     .where("name", "containsSimilar", searchText)
                     .limit(20)
                     .get()
                    .then(lotteryFilters => {
                        this._database.getCurrentCustomer()
                            .getLottery(lotteryId)
                            .getFilters() 
                            .getCollection()
                              .where("name", "containsSimilar", searchText)
                     .limit(20)
                     .get()
                            .then(customerFilters => {

                              
                               const resultList = [...lotteryFilters.docs, ...customerFilters.docs];

                             
                                resolve(resultList.map(x=>x.data()));

                            })
                            .catch(error => {
                                reject(error);
                            })

                    })
                    .catch(error => {
                        reject(error);
                    })
           
     

        });

        return promise;


    }

    public getCurrentLotteryFilters(): Promise<Filter[]> {


        let promise = new Promise<Filter[]>((resolve, reject) => {
            if (this.lotteryFilters == null || this.lotteryFilters.length == 0 || this.filterslotteryId != this.lotteryId) {


                this._database
                    .getLottery(this.lotteryId)
                    .getFilters()
                    .getData()
                    .then(lotteryFilters => {
                        this._database.getCurrentCustomer()
                            .getLottery(this.lotteryId)
                            .getFilters()
                            .getData()
                            .then(customerFilters => {

                                this.lotteryFilters = [...lotteryFilters, ...customerFilters];

                                this.filterslotteryId = this.lotteryId;

                                resolve(this.lotteryFilters);

                            })
                            .catch(error => {
                                reject(error);
                            })

                    })
                    .catch(error => {
                        reject(error);
                    })
            }
            else {

                console.log("ja tem os filtros");

                resolve(this.lotteryFilters);
            }


        });

        return promise;


    }

  public getCurrentLotteryFilter(filterId,lotteryId): Promise<Filter> {


        let promise = new Promise<Filter>((resolve, reject) => {
      
                this._database
                    .getLottery(lotteryId)
                    .getFilter(filterId)                    
                    .getData()
                    .then(filter => {
                        if(filter)
                        {
                            resolve(filter);
                            return;
                        }
                        else{
                        this._database.getCurrentCustomer()
                            .getLottery(lotteryId)
                            .getFilters()
                            .getFilter(filterId)
                            .getData()
                            .then(customerFilter => {

                              
                                resolve(customerFilter);

                            })
                            .catch(error => {
                                reject(error);
                            })
                        }
                    })
                    .catch(error => {
                        reject(error);
                    })
           

        });

        return promise;


    }
    public getCurrentLotteryModeOld(): Promise<Lottery> {


        let promise = new Promise<Lottery>((resolve, reject) => {


            this.http.get(`http://localhost:3000/lottery-modes?Id=${this.lotteryId}`).toPromise()
                .then(data => {
                    this.lottery = data[0];



                    this.observers.forEach(observer => {
                        observer.next(this.lottery);
                    });

                    resolve(this.lottery);
                })
                .catch(error => {

                    reject(error);
                })



        });

        return promise;


    }


    // public getLotteryModesOld(): Promise<Lottery[]> {

    //     return this.http.get("http://localhost:3000/lottery-modes").toPromise()
    //         .then((data:Lottery[]) => {
    //             return this.lottery = data;


    //         })
    //         .catch(error => {
    //             console.log(error);
    //             return [];
    //         })

    // }


    public updateBet(bet: Bet): Promise<any> {
        return this._database.updateBet(bet, this.lotteryId).
            then((bet) => {
            });
    }


    deleteBet(id: string): Promise<any> {

        return this._database.getCurrentCustomer()
            .getLottery(this.lotteryId)
            .getBet(id)
            .getData()
            .then(bet => {

                let finalDelete = () => {

                    let userId = this.auth.getCurrentUserId();

                    let fileToRemove = `lottolocos/${userId}/lotteries\/${this.lotteryId}/bets/${id}/${bet.solutionFileName}.dat`;

                    this._database.getCurrentCustomer()
                        .getLottery(this.lotteryId)
                        .getBets()
                        .getBet(id)
                        .delete()
                        .then(() => {
                            this._database.getRecycles()
                                .add({ filePath: fileToRemove })
                                .then();
                        });
                };
                finalDelete();



            });


    }


    createResultsLayout(lottery: Lottery): MyDictionary<any> {


        let rangeLayouts: MyDictionary<any> = new MyDictionary<any>();

        lottery.awardParams.forEach((awardRange => {


            let awardsColumns = { description: awardRange.description, index: parseInt(awardRange.index.toString()), resultsColumns: [], jockerResultsColumns: [] };

            rangeLayouts[awardRange.index] = awardsColumns;



            let awards = [...awardRange.awards];

            awards = awards.sort((a, b) => b - a);

            let jockerAwards = [];

            if (awardRange.jockerAwards != null) {
                jockerAwards = awardRange.jockerAwards.reverse();
            }


            //era aquiiiiiiiiiiii


            for (let i = 0; i <= awardRange.amountDrawn; i++) {

                let color = "#FFFFFF";

                let pos = awards.findIndex(x => x == i)

                if (pos >= 0) {
                    if (pos < 5) {
                        color = "color" + pos;
                    }
                    else {
                        color = "normal";
                    }
                }
                else {
                    color = "normal";
                }

                if (i > 1) {
                    awardsColumns.resultsColumns.push(
                        {
                            ref: "col" + i.toString(),
                            description: i.toString() + " acertos",
                            index: i,
                            color: color
                        });
                }
                else {
                    awardsColumns.resultsColumns.push(
                        {
                            ref: "col" + i.toString(),
                            description: i.toString() + " acerto",
                            index: i,
                            color: color
                        });
                }
            }


            if (awardRange.jockerAmountDrawn > 0) {
                for (let i = 0; i <= awardRange.jockerAmountDrawn; i++) {

                    let color = "#FFFFFF";

                    let pos = awards.findIndex(x => x == i)

                    if (pos >= 0) {
                        if (pos < 5) {
                            color = "color" + pos;
                        }
                        else {
                            color = "normal";
                        }
                    }
                    else {
                        color = "normal";
                    }

                    if (i > 1) {
                        awardsColumns.jockerResultsColumns.push(
                            {
                                ref: "col" + i.toString(),
                                description: i.toString() + ' ' + lottery.JockersName,
                                index: i,
                                color: color
                            });
                    }
                    else {
                        awardsColumns.jockerResultsColumns.push(
                            {
                                ref: "col" + i.toString(),
                                description: i.toString() + ' ' + lottery.JockerName,
                                index: i,
                                color: color
                            });
                    }
                }
            }

            awardsColumns.resultsColumns = awardsColumns.resultsColumns.reverse();

        }));


        return rangeLayouts;
    }

    // public forceFinish(taskId: string): Promise<void> {

    //     let promise = new Promise<void>((resolve) => {

    //         let updateFields = { status: <number>LotteryTaskStatuses.Waiting, forceFinish: true }

    //         let promiseAll = Promise.all([

    //             this._database.getCurrentCustomer()
    //                 .getProcessingTasks()
    //                 .getTask(taskId)
    //                 .getData()
    //                 .then(data => {
    //                     if (data != null) {
    //                         this._database.getCurrentCustomer()
    //                             .getProcessingTasks()
    //                             .getTask(taskId)
    //                             .updateFields(updateFields)
    //                             .then();
    //                     }

    //                 }),

    //             this._database.getCurrentCustomer()
    //                 .getWaitingTasks()
    //                 .getTask(taskId)
    //                 .getData()
    //                 .then(data => {
    //                     if (data != null) {
    //                         this._database.getCurrentCustomer()
    //                             .getWaitingTasks()
    //                             .getTask(taskId)
    //                             .updateFields(updateFields)
    //                             .then();
    //                     }
    //                 })]);

    //         promiseAll.then(() => {
    //             resolve();
    //         })
    //     });

    //     return promise;
    // }



    // public addBetold(bet: Bet): Promise<any> {


    //     let promise =  new Promise<any>((resolve)=>
    //     {


    //     let task = new LotteryTask();

    //     task.taskType = BetTaskTypes.Cover;
    //     task.createDate = new Date().getTime();
    //     task.status = LotteryTaskStatuses.Waiting;

    //     bet.Tasks = [task];

    //     this._database.addBet(bet, this.lotteryId).
    //         then((bet) => {

    //             let taskQueue = new TaskQueue();

    //             taskQueue.TaskId = bet.Tasks[0].id;

    //             taskQueue.LotteryId = this.lotteryId;

    //             taskQueue.BetId = bet.id;

    //             taskQueue.status = LotteryTaskStatuses.Waiting;

    //           //  this.router.navigate([`/bets/${this.lotteryId}/list`]);
    //             this._database.addTaskQueue(taskQueue)
    //                 .then(() => {

    //                     bet.lotteryId = this.lotteryId;

    //                  resolve(bet);
    //                 });

    //         });

    //     //   this.router.navigate(['/bets']);

    // });

    // return promise;

    // }


}

